import { Role } from 'constants/roles';

import { useApiContext } from 'context/apiContext';
import { WorkTeam } from 'types/embedded/workTeam';
import { getId } from 'utils';

export function useEditWorkGroupAccess() {
  const { user } = useApiContext();

  const hasEditWorkGroupAccess = (record: WorkTeam) => {
    return (
      !user.roles.includes(Role.FinanceLead) ||
      getId(String(record?.manager?.id)) === String(user.id)
    );
  };

  return { hasEditWorkGroupAccess };
}
